import React from 'react';
import styled, { css } from 'styled-components';
import BaseTextInput, { TextInputProps } from '../base-text-input/base-text-input';
import mergeClassNames from '../../lib/style-helpers/merge-class-name';
import { InputStateStyleProps } from '../../../../types/input-state-style-props';

function TextInput({
  className,
  ...props
}: TextInputProps) {
  return (
    <Input
      className={mergeClassNames('TextInput', className ?? '')}
      {...props}
    />
  );
}

const Input = styled(BaseTextInput) < InputStateStyleProps > `
  ${({ theme }) => css`
    padding: 8px 8px;
    ${theme.font(theme.inputType.fontWeight, theme.inputType.fontSize)}
    letter-spacing: ${theme.inputType.letterSpacing};
    text-align: center;
    border-bottom: ${theme.inputType.borderBottom};
    ::placeholder {
      color: ${theme.inputType.placeholderColor};  
      letter-spacing: 0; 
      font-size: ${theme.inputType.placeholderFontSize};
    }  
    ${theme.media.tablet} {
      font-size: 22px;
      line-height: 59px;
      padding: 4px 4px;
      ::placeholder {
        font-size: 20px;
    }
  `}
`;

export default TextInput;
